export const GOOGLE_IDS = {
  webClientId:
    '435377160174-0f0l1j1d4keghvurspbral7svvvapoo9.apps.googleusercontent.com',
  iosClientId:
    '435377160174-dj80do77eusnvfpkfq448c54djrsq5mi.apps.googleusercontent.com',
};
